import React from 'react';

interface ActionInfoProps {
  data: {
    message: string;
    [key: string]: any;
  };
}

const ActionInfo: React.FC<ActionInfoProps> = ({ data }) => {
  return (
    <div className="text-sm text-gray-200 italic">
      <p>{data.message}</p>
    </div>
  );
};

export default ActionInfo; 